const $bannerVideo = document.querySelector('[data-role=video-decor]') as HTMLElement;
const $cursorDecor = document.querySelector('[data-role=cursor-decor]') as HTMLElement;
const $videoContainer = document.querySelector('[data-role=video-container]') as HTMLElement;
const $closeButtonEl  = document.querySelector('[data-role=close-button]') as HTMLElement;
const $banner = document.querySelector('[data-role=banner]') as HTMLElement;
const $overlay = document.querySelector('[data-role=banner-overlay]') as HTMLElement;
const $bodyEl = document.querySelector('body') as HTMLElement;
const isMobile = window.outerWidth < 768;
const $scrollToAnchor = document.querySelector('[data-role=scroll-to-anchor]') as HTMLElement;
const $startAnchor = document.querySelector('[data-role=start-anchor]') as HTMLElement;

let isClosing = false;
let touchStartY = 0;

$bannerVideo.addEventListener('click', onBannerVideoClick);
$closeButtonEl.addEventListener('click', onCloseButtonClick);
$scrollToAnchor.addEventListener('click', onScrollToAnchorClick);

if (window.outerWidth > 1024) {
	$bannerVideo.addEventListener('mousemove', onBannerVideoMousemove);
	$bannerVideo.addEventListener('mouseout', onBannerVideoMouseout);
}

function enableWheelListener() {
	window.addEventListener('wheel', onWheel, { passive: false });
}

function disableWheelListener() {
	window.removeEventListener('wheel', onWheel);
}

function onWheel(event: WheelEvent) {
	if (isClosing) return;

	if ($banner.classList.contains('_fullscreen') && event.deltaY > 0) {
	    event.preventDefault();
	    isClosing = true;

	    scrollToAnchorWithTimeout(() => {
	        isClosing = false;
	        disableWheelListener();
	    });
	}
}

function onBannerVideoMousemove(event) {
	$cursorDecor.style.position = 'fixed';
	$cursorDecor.style.left = event.clientX + -70 + 'px';
	$cursorDecor.style.top = event.clientY + -70 + 'px';
	$cursorDecor.style.opacity = '1';
}

function hideCursorDecor() {
	$cursorDecor.style.opacity = '0';
}

function onBannerVideoMouseout() {
	hideCursorDecor();
}

function showOverlay() {
	$overlay.classList.add('_visible');
}

function hideOverlay() {
	$overlay.classList.remove('_visible');
}

function pauseVideo($video) {
	$video.pause();
}

function playVideo($video) {
	$video.play();
}

function restartVideo($video, $copyVideo) {
	$video.remove();

	Array.from($videoContainer.querySelectorAll('video')).forEach(video => video.remove());

	$videoContainer.appendChild($copyVideo);
}

function findVideoElement() {
	return document.querySelector('[data-role=video]') as HTMLVideoElement;;
}

function findCopyVideo($video) {
	return $video.cloneNode(true) as HTMLVideoElement;
}

function setVideoSource($video, videoId) {
	$video.querySelector('source')?.setAttribute('src', `https://cdn.naos.ru/media/landing/etatpur_brand/${videoId}.mp4`);
}

function onBannerVideoClick() {
	hideCursorDecor();
	
	const $video = findVideoElement();
	const $copyVideo = findCopyVideo($video);

	$video.removeAttribute('muted');

	pauseVideo($video);
	pauseVideo($copyVideo);
	showOverlay();
	
	$overlay.style.top = '0';

	setTimeout(()=> {
		if (isMobile) {
			setVideoSource($copyVideo, 'banner-video-mobile');
			$copyVideo.setAttribute('controls', 'controls');
			$copyVideo.load();
		}

		$overlay.style.top = '100%';
		$banner.classList.add('_fullscreen');

		enableWheelListener();
	}, 1000);

	setTimeout(()=> {
		$copyVideo.volume = .5;

		restartVideo($video, $copyVideo);
		playVideo($copyVideo);
		hideOverlay();

		$bodyEl.style.overflowY = 'hidden';
	}, 1500);
}

function onCloseButtonClick() {
	const $video = findVideoElement();

	pauseVideo($video);
	showOverlay();

	$video.setAttribute('muted', 'true');

	const $copyVideo = findCopyVideo($video);

	$overlay.style.top = '0';

	setTimeout(()=> {
		if (isMobile) {
			setVideoSource($copyVideo, 'banner-video-new');
			$copyVideo.removeAttribute('controls');
			$copyVideo.load();
		}

		$overlay.style.top = '-100%';
		$banner.classList.remove('_fullscreen');
		
		disableWheelListener();
	}, 1000);

	setTimeout(()=> {
		restartVideo($video, $copyVideo);
		playVideo($copyVideo);
		hideOverlay();

		$cursorDecor.removeAttribute('style');
		$bodyEl.removeAttribute('style');
	}, 1500);
};

function scrollToAnchorWithTimeout(callback?: () => void) {
	const $header = document.querySelector('[data-role=header]') as HTMLElement;
	const headerHeight = $header ? $header.offsetHeight : 0;
	const elementTop = $startAnchor.getBoundingClientRect().top + window.scrollY;

	$closeButtonEl.click();

	setTimeout(()=> {
		window.scrollTo({
			top: elementTop - headerHeight,
			behavior: 'smooth'
		});
		
		if (callback) callback();
	}, isMobile ? 500 : 700);
}

function  onScrollToAnchorClick() {
	if ($banner.classList.contains('_fullscreen')) {
		scrollToAnchorWithTimeout();

		return;
	}

	const $header = document.querySelector('[data-role=header]') as HTMLElement;
	const headerHeight = $header ? $header.offsetHeight : 0;
	const elementTop = $startAnchor.getBoundingClientRect().top + window.scrollY;

	window.scrollTo({
		top: elementTop - headerHeight,
		behavior: 'smooth'
	});
}
 
window.addEventListener('wheel', (event) => {
	if (isClosing) return;

	if ($banner.classList.contains('_fullscreen') && event.deltaY > 0) {
		event.preventDefault();

		isClosing = true;

		scrollToAnchorWithTimeout(() => isClosing = false);
	}
}, { passive: false });

window.addEventListener('touchstart', (event) => {
	touchStartY = event.touches[0].clientY;
}, { passive: true });

window.addEventListener('touchend', (event) => {
	if (isClosing) return;

	const touchEndY = event.changedTouches[0].clientY;
	const deltaY = touchStartY - touchEndY;

	if ($banner.classList.contains('_fullscreen') && deltaY > 30) {
		isClosing = true;
		scrollToAnchorWithTimeout(() => isClosing = false);
	}
}, { passive: true });